import * as React from 'react';

function SvgProgressLinkout(props) {
  return (
    <svg viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.3 8.75a.75.75 0 011.5 0v8a.75.75 0 11-1.5 0v-8zm2.72 9.47a.75.75 0 011.06 1.06l-2.5 2.5a.75.75 0 01-1.06 0l-2.5-2.5a.75.75 0 011.06-1.06l1.97 1.97 1.97-1.97zM1.96 16h14.038L9 2.387 1.96 16zM9.63.396l8.282 16a.75.75 0 01-.661 1.104H.751a.75.75 0 01-.672-1.083L8.3.417A.747.747 0 019.63.396z" />
    </svg>
  );
}

export default SvgProgressLinkout;
